import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface PageHeaderProps {
    title: string;
    description?: React.ReactNode;
    children?: React.ReactNode;
    className?: string;
}

export function PageHeader({
    title,
    description,
    children,
    className
}: PageHeaderProps) {
    return (
        <div className={cn("flex flex-col md:flex-row md:items-center md:justify-between mb-8 gap-4", className)}>
            <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1 }}
            >
                <h1 className="text-2xl font-semibold mb-2 text-foreground">
                    {title}
                </h1>
                {description && (
                    <div className="text-muted-foreground flex items-center gap-2">
                        {description}
                    </div>
                )}
            </motion.div>

            {children && (
                <motion.div
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.1, delay: 0.05 }}
                    className="flex items-center gap-2"
                >
                    {children}
                </motion.div>
            )}
        </div>
    );
}
